import { cssProp, view, View } from '@esui/core';
import '@material/mwc-icon-button';
import { html, nothing, SVGTemplateResult, TemplateResult } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

export { IconButton as MdcIconButton } from '@material/mwc-icon-button';

class Props {
  icon?: string | View | TemplateResult | SVGTemplateResult = '';
  label = '';
  disabled = false;
  @cssProp('--mdc-icon-size')
  iconSize?: string = undefined;
  @cssProp('--mdc-icon-button-size')
  buttonSize?: string = undefined;
}

export const [IconButton] = view('esui-mwc-icon-button', {
  Props,

  mapBuilder:
    IconButtonBuilder =>
    (icon: string | TemplateResult | SVGTemplateResult | View) =>
      IconButtonBuilder().icon(icon),

  template(props) {
    let slotIcon: any;
    let icon: string | undefined;

    if (typeof props.icon === 'string') {
      slotIcon = undefined;
      icon = props.icon;
    } else {
      slotIcon = props.icon instanceof View ? props.icon.body : props.icon;
      icon = undefined;
    }

    return html`
      <mwc-icon-button
        label="${props.label}"
        ?disabled="${props.disabled}"
        icon="${ifDefined(icon)}"
      >
        ${slotIcon || nothing}
      </mwc-icon-button>
    `;
  },
});
